import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  user = {
    name: '',
    email: '',
    password: '',
    tfaCode: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;

  constructor(Auth, $state, WebAccessService, SettingsService, $timeout, $interval, $scope) {
    'ngInject';
    this.$state = $state;
    this.Auth = Auth;
    this.WebAccessService = WebAccessService;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$scope = $scope;

    this.name = "";

    this.timer = null;
    this.RESEND_DELAY_SECONDS = 60;
    this.resendDelay = 0;

    this.otpInput={
      size:4,
      type:"text",
      onDone: (value) => {
        this.user.tfaCode = value;
      },
      onChange: (value) => {
        this.user.tfaCode = value;
      }
    };

    this.resetOtp = () => {
      this.otpInput.resetOtp();
      this.user.tfaCode = this.otpInput.value;
    }

    this.resend2FA = () => {
      this.resetOtp();
      this.$timeout(() => {
        this.login(this.$scope.form);
      })
    }

    this.startResendTimer = () => {
      this.resendDelay = this.RESEND_DELAY_SECONDS;
      if (this.timer) this.$interval.cancel(this.timer);
      this.timer = this.$interval(() => {
        this.resendDelay--;
        if (this.resendDelay <= 0) {
          this.$interval.cancel(this.timer);
        }
      }, 1000);
    }

    SettingsService.getByName({name: 'config.platform'}, settings => {
      this.client = settings.data.clientName;
      this.forgotPasswordLink = settings.data.forgotPasswordLink;
    })

    SettingsService.getByName({name: 'client'}, settings => {
      let imageUrl = settings.data.frontpage ? '/api/storage/' + settings.data.frontpage : '/assets/images/frontpage.jpeg';
      jQuery(".frontpage").css('background-image', 'url(' + imageUrl + ')');
    })
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email.toLowerCase(),
        password: this.user.password,
        tfaCode: this.user.tfaCode
      })
        .then(user => {

          console.log(user);

          if (user.role.includes('admin')) {
            // Logged in, redirect to home
            this.$state.go('admin-home');
          } else {
            if (user.provider === 'local-webaccess') {
              this.WebAccessService.updateLastLoggedIn({webaccessId: user.webaccessId}, {date: new Date()});
            }
            // Logged in, redirect to home
            this.$state.go('home');
          }

        })
        .catch(err => {

          if (err.action && err.action == "REQUIRES_2FA_EMAIL") {
            this.tfaPrompt = true;

            this.$timeout(()=>{
              this.resetOtp(); // reset and focus!
              this.startResendTimer();
            },0)

          } else {
            this.errors.login = Array.isArray(err) ? err[0].message : err.message;

            // Falls der fehler beim 2FTP code ist, dann diesen löschen
            if (this.tfaPrompt) {
              this.$timeout(()=>{
                this.resetOtp(); // reset and focus!
              },0)
            }
          }
        });
    }
  }
}

export default angular.module('conduu.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js